import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

export default function PortalImpressum() {
  const q = useQuery({
    queryKey: ["portal-settings"],
    queryFn: async () => (await api.get("/portal/settings")).data,
  });
  const impressum = q.data?.impressum || "";
  return (
    <div className="space-y-4" data-testid="portal-impressum">
      <div>
        <div className="text-3xl font-black uppercase tracking-tight">Impressum</div>
      </div>
      {q.isLoading && <div className="text-zinc-500">Lade…</div>}
      {!q.isLoading && !impressum && (
        <div className="border border-dashed border-zinc-800 rounded-sm p-8 text-center text-zinc-500">
          Impressum wird gerade gepflegt.
        </div>
      )}
      {impressum && (
        <div className="border border-zinc-800 rounded-lg p-6 bg-zinc-900 whitespace-pre-wrap text-sm text-zinc-300 leading-relaxed">
          {impressum}
        </div>
      )}
    </div>
  );
}
